export const SDK_VERSION = '8.37.1';
